export default __webpack_public_path__ + "static/four-pack-front-1ac8c17e0eb066102b762f34271a7fff.png";